import { AsyncPipe, CommonModule } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { SmartQuoteService } from 'src/app/core/services/smartquote/smartquote.service'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { SmartQuoteFilter } from 'src/app/shared/interfaces/smartquote/smart-quote-filter.interface'
import { SmartQuoteListItem } from 'src/app/shared/interfaces/smartquote/smart-quote-list-item.interface'
import { SmartquoteTableComponent } from './components/smartquote-table/smartquote-table.component'
import { CardComponent } from 'src/app/shared/components/card/card.component'
import { SmartquoteSearchComponent } from './components/smartquote-search/smartquote-search.component'
import { SmartquoteHelperService } from './smartquote-helper.service'
import { EmptyComponent } from 'src/app/shared/components/empty/empty.component'
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap'
import { PaginationDetailComponent } from 'src/app/shared/components/pagination-detail/pagination-detail.component'
import { RouterModule } from '@angular/router'
import { NgApexchartsModule } from 'ng-apexcharts'
import { SmartquoteNavComponent } from './components/smartquote-nav/smartquote-nav.component'

@Component({
    selector: 'sf-smartquotes',
    imports: [
        RouterModule,
        NgbPaginationModule,
        NgApexchartsModule,
        CardComponent,
        SmartquoteTableComponent,
        SmartquoteSearchComponent,
        EmptyComponent,
        PaginationDetailComponent,
        AsyncPipe,
    ],
    templateUrl: './smartquotes.component.html',
    styleUrls: ['./smartquotes.component.scss'],
})
export class SmartquotesComponent implements OnInit {
    private smartQuoteService = inject(SmartQuoteService)
    public smartQuoteHelperService = inject(SmartquoteHelperService)

    smartQuotes$!: Observable<PaginatedList<SmartQuoteListItem>>

    ngOnInit(): void {
        this.loadSmartQuotes()
    }

    loadSmartQuotes(): void {
        this.smartQuotes$ = this.smartQuoteService.getSmartQuotesPaged(this.smartQuoteHelperService.filter())
    }

    onPageChange(pageNumber: number): void {
        this.smartQuoteHelperService.updateFilter({ ...this.smartQuoteHelperService.filter(), pageNumber })
        this.loadSmartQuotes()
    }

    onFilterChange(filter: SmartQuoteFilter): void {
        this.smartQuoteHelperService.updateFilter(filter)
        this.loadSmartQuotes()
    }
}
